const AuditEnum = {
    2: "Read",
    4: "Activity",
};

export {
    AuditEnum,
}